import classnames from 'classnames'

import { INVOICE_STATUS_COLOR_MAP, INVOICE_STATUSES, InvoiceStatusEnum } from '@/enums'
import { InvoiceStatusColorType, InvoiceStatusDataType } from '@/types'

export class InvoiceStatus {
    key: InvoiceStatusEnum

    title: string

    color: InvoiceStatusColorType

    constructor(data: InvoiceStatusDataType) {
        this.key = data.key
        this.title = data.title
        this.color = data.color
    }

    static get all() {
        return INVOICE_STATUSES.map(item => new InvoiceStatus(item))
    }

    static find(key: InvoiceStatusEnum) {
        return InvoiceStatus.all.find(item => item.key === key) || InvoiceStatus.defaultValue
    }

    static get defaultValue() {
        return InvoiceStatus.all.find(item => item.key === InvoiceStatusEnum.UNPAID) as InvoiceStatus
    }

    get colors() {
        return INVOICE_STATUS_COLOR_MAP[this.color]
    }

    get badge() {
        return <span className={classnames('inline-block rounded-2xl px-2 py-1', this.colors.bg, this.colors.text)}>
            {this.title}
        </span>
    }
}
